import {
  Search, Landmark, FileSearch, LineChart, Building2, Scale, TrendingUp,
  ShieldCheck, Gauge, Eye, Handshake, Users, Award, HandCoins
} from "lucide-react";

export const navLinks = [
  { label: "Home", path: "/", slug: "home" },
  { label: "Chi Siamo", path: "/chi-siamo", slug: "chi-siamo" },
  { label: "Servizi", path: "/servizi", slug: "servizi" },
  { label: "Perché Noi", path: "/perche-noi", slug: "perche-noi" },
  { label: "Management", path: "/management", slug: "management" },
  { label: "FAQ", path: "/faq", slug: "faq" },
  { label: "Contatti", path: "/contatti", slug: "contatti" },
];

export const services = [
  {
    id: "analisi-selezione",
    icon: Search,
    title: "Analisi e Selezione",
    short: "Analisi e selezione di portafogli NPL (Non Performing Loans) e UTP (Unlikely To Pay).",
    description: "Ogni operazione nasce da un'analisi rigorosa: studiamo la composizione del portafoglio, la qualità dei sottostanti e il profilo di rischio di ogni singola posizione, per selezionare solo le opportunità in grado di generare valore reale.",
    vantaggi: ["Screening data-driven dei portafogli", "Valutazione del rischio per singola posizione", "Prioritizzazione delle opportunità di valore"],
    processo: ["Raccolta e normalizzazione dei dati", "Analisi statistica e scoring", "Shortlist delle opportunità"],
  },
  {
    id: "acquisto-portafogli",
    icon: Landmark,
    title: "Acquisto Portafogli",
    short: "Acquisto di portafogli di crediti secured e unsecured.",
    description: "Acquistiamo direttamente portafogli di crediti deteriorati secured e unsecured, con un processo decisionale snello e closing rapidi, garantendo al cedente certezza di esecuzione e massima riservatezza.",
    vantaggi: ["Capacità di investimento diretta", "Closing rapidi e strutturati", "Soluzioni per crediti secured e unsecured"],
    processo: ["Manifestazione di interesse", "Due diligence e pricing", "Closing e perfezionamento"],
  },
  {
    id: "due-diligence",
    icon: FileSearch,
    title: "Due Diligence",
    short: "Due diligence economica, finanziaria, immobiliare e documentale.",
    description: "Conduciamo due diligence complete su portafogli e singole posizioni: analisi economica e finanziaria, verifiche immobiliari e urbanistiche, controllo della documentazione legale e della titolarità dei crediti.",
    vantaggi: ["Analisi economica, finanziaria e immobiliare", "Verifica documentale completa", "Report chiari e orientati alla decisione"],
    processo: ["Review della data room", "Verifiche legali e immobiliari", "Report finale con raccomandazioni"],
  },
  {
    id: "servicing-asset-management",
    icon: LineChart,
    title: "Servicing & Asset Management",
    short: "Gestione e valorizzazione dei crediti mediante attività di servicing e asset management.",
    description: "Gestiamo attivamente i crediti lungo tutto il loro ciclo di vita, definendo per ogni posizione la strategia di valorizzazione più efficace e monitorando i risultati con reportistica periodica e trasparente.",
    vantaggi: ["Gestione attiva e dedicata dei crediti", "Strategie di valorizzazione su misura", "Reportistica periodica e trasparente"],
    processo: ["Onboarding e presa in carico", "Definizione della strategia per posizione", "Monitoraggio e reporting continuo"],
  },
  {
    id: "possessing-immobiliare",
    icon: Building2,
    title: "Possessing Immobiliare",
    short: "Gestione delle posizioni fino al possessing, con acquisizione e valorizzazione degli immobili sottostanti.",
    description: "Quando la valorizzazione passa dall'asset reale, gestiamo le posizioni fino al possessing degli immobili, occupandoci dell'acquisizione, della messa a reddito e del remarketing per massimizzare il recovery value.",
    vantaggi: ["Acquisizione degli immobili sottostanti", "Valorizzazione e messa a reddito", "Massimizzazione del recovery value"],
    processo: ["Strategia di possessing", "Acquisizione e sanatoria dell'asset", "Remarketing e vendita"],
  },
  {
    id: "recupero-crediti",
    icon: Scale,
    title: "Recupero Crediti",
    short: "Recupero del credito in fase stragiudiziale e coordinamento delle attività giudiziali tramite professionisti specializzati.",
    description: "Privilegiamo il recupero stragiudiziale, più rapido ed efficiente, e coordiniamo le attività giudiziali avvalendoci di un network di professionisti legali specializzati nel diritto bancario e delle esecuzioni.",
    vantaggi: ["Recupero stragiudiziale rapido", "Coordinamento delle azioni giudiziali", "Network di professionisti specializzati"],
    processo: ["Analisi della posizione debitoria", "Negoziazione e accordi stragiudiziali", "Eventuale azione giudiziale coordinata"],
  },
  {
    id: "trading-portafogli",
    icon: TrendingUp,
    title: "Trading di Portafogli",
    short: "Attività di trading di portafogli e singole posizioni creditizie.",
    description: "Operiamo sul mercato secondario dei crediti con attività di trading su portafogli e singole posizioni, offrendo liquidità e valutazioni di mercato puntuali a investitori e intermediari.",
    vantaggi: ["Liquidità per portafogli e singole posizioni", "Valutazioni di mercato aggiornate", "Esecuzione rapida delle operazioni"],
    processo: ["Valutazione dell'opportunità", "Strutturazione dell'operazione", "Esecuzione e settlement"],
  },
  {
    id: "supporto-investitori",
    icon: HandCoins,
    title: "Supporto a Investitori",
    short: "Supporto a investitori, fondi e operatori del mercato nell'individuazione di opportunità di investimento nel settore immobiliare e finanziario.",
    description: "Affianchiamo investitori, fondi e operatori del mercato nella ricerca e nella selezione di opportunità di investimento nei settori immobiliare e finanziario, mettendo a disposizione la nostra conoscenza del mercato dei crediti deteriorati e una rete consolidata di relazioni.",
    vantaggi: ["Accesso a opportunità selezionate e off-market", "Analisi e strutturazione dell'investimento", "Expertise nei settori immobiliare e finanziario"],
    processo: ["Definizione del profilo di investimento", "Individuazione e screening delle opportunità", "Strutturazione e accompagnamento dell'operazione"],
  },
];

export const strengths = [
  { icon: Award, title: "Esperienza consolidata", text: "Un team con oltre quindici anni di esperienza nel mercato dei crediti deteriorati, tra origination, servicing e recupero." },
  { icon: Gauge, title: "Velocità operativa", text: "Processi snelli e decisioni tempestive: dall'analisi all'offerta in tempi rapidi, per cogliere ogni opportunità di valore." },
  { icon: Eye, title: "Trasparenza totale", text: "Comunicazione chiara e reportistica puntuale in ogni fase del processo, senza sorprese per i nostri partner." },
  { icon: Users, title: "Consulenza personalizzata", text: "Ogni portafoglio è unico: costruiamo soluzioni su misura per banche, investitori e imprese." },
  { icon: Handshake, title: "Partnership istituzionali", text: "Rapporti duraturi con banche, fondi, investitori e intermediari finanziari, basati su fiducia e risultati." },
  { icon: TrendingUp, title: "Risultati misurabili", text: "Ogni strategia è orientata al recupero e alla valorizzazione, con obiettivi chiari e performance tracciate." },
];

export const stats = [
  { value: 500, prefix: "€", suffix: "M+", label: "Portafogli analizzati" },
  { value: 12000, suffix: "+", label: "Posizioni lavorate" },
  { value: 15, suffix: "+", label: "Anni di esperienza" },
  { value: 30, suffix: "+", label: "Partner istituzionali" },
];

export const processSteps = [
  { num: "01", title: "Analisi & Due Diligence", text: "Studio approfondito del portafoglio: valutazione economica, finanziaria, immobiliare e documentale." },
  { num: "02", title: "Valutazione & Offerta", text: "Pricing accurato e proposta di acquisto o mandato di gestione su misura per il cliente." },
  { num: "03", title: "Servicing & Gestione", text: "Attività di asset management, servicing e coordinamento delle azioni stragiudiziali e giudiziali." },
  { num: "04", title: "Valorizzazione & Reporting", text: "Recupero, possessing immobiliare e reportistica trasparente e puntuale in ogni fase." },
];

export const values = [
  { icon: ShieldCheck, title: "Affidabilità", text: "Operiamo nel pieno rispetto della normativa vigente e delle autorizzazioni di legge, con rigore e integrità." },
  { icon: Gauge, title: "Rapidità decisionale", text: "Processi snelli e decisioni tempestive per cogliere ogni opportunità di valore sul mercato." },
  { icon: Eye, title: "Trasparenza", text: "Comunicazione chiara e reportistica puntuale in ogni fase del processo, verso clienti e partner." },
  { icon: Handshake, title: "Partnership", text: "Un rapporto di fiducia duraturo con banche, investitori e imprese, costruito sui risultati." },
];

export const timeline = [
  { year: "2016", title: "La fondazione", text: "Vobis Credit nasce dall'incontro di professionisti della finanza e del diritto, con l'obiettivo di portare un approccio nuovo alla gestione dei crediti deteriorati." },
  { year: "2018", title: "I primi portafogli", text: "Le prime acquisizioni di portafogli NPL e UTP consolidano il modello operativo: analisi rigorosa, pricing accurato, gestione attiva." },
  { year: "2021", title: "Crescita e strutturazione", text: "Il team si rafforza con competenze finanziarie, legali e immobiliari, integrando l'intero ciclo di vita del credito in un unico partner." },
  { year: "2024", title: "Nuove partnership", text: "Si amplia la rete di relazioni con banche, fondi, investitori e intermediari finanziari, in Italia e all'estero." },
  { year: "Oggi", title: "Un operatore integrato", text: "Vobis Credit è oggi un operatore specializzato lungo l'intera filiera: dall'origination al recupero, fino alla valorizzazione degli asset." },
];

export const faqs = [
  { q: "Cosa sono i crediti NPL e UTP?", a: "Gli NPL (Non Performing Loans) sono crediti in sofferenza, per i quali il debitore non è più in grado di adempiere regolarmente alle proprie obbligazioni. Gli UTP (Unlikely To Pay) sono esposizioni per cui la banca ritiene improbabile il rimborso integrale senza il ricorso ad azioni come l'escussione delle garanzie. Vobis Credit acquista, gestisce e valorizza entrambe le tipologie." },
  { q: "A chi si rivolge Vobis Credit?", a: "Ci rivolgiamo a banche, intermediari finanziari, fondi di investimento, investitori istituzionali e imprese che desiderano cedere, valorizzare o gestire portafogli di crediti deteriorati, offrendo a ciascuno soluzioni su misura." },
  { q: "Gestite crediti secured e unsecured?", a: "Sì. Operiamo sia su crediti secured, assistiti da garanzie reali come ipoteche su immobili, sia su crediti unsecured. Per le posizioni secured gestiamo anche il possessing e la valorizzazione degli immobili sottostanti." },
  { q: "Come avviene il recupero del credito?", a: "Privilegiamo il recupero in fase stragiudiziale, più rapido ed efficiente, attraverso negoziazioni e accordi con i debitori. Quando necessario, coordiniamo le attività giudiziali avvalendoci di professionisti legali specializzati." },
  { q: "Con quali autorizzazioni operate?", a: "Operiamo nel rispetto della normativa vigente e delle autorizzazioni previste dalla legge, tra cui quelle di cui all'art. 115 T.U.L.P.S. e, ove applicabili, alla disciplina prevista dagli artt. 114 e seguenti del Testo Unico Bancario." },
  { q: "Come viene valutato un portafoglio?", a: "Attraverso una due diligence completa: analisi economica e finanziaria delle posizioni, verifiche immobiliari sui sottostanti, controllo della documentazione legale e modelli di pricing proprietari. Il risultato è una valutazione accurata e trasparente." },
  { q: "Quanto dura il processo di acquisto?", a: "Dipende dalla complessità del portafoglio, ma il nostro processo decisionale è snello: una volta completata la due diligence, siamo in grado di formulare un'offerta e arrivare al closing in tempi rapidi." },
  { q: "Operate su tutto il territorio nazionale?", a: "Sì, operiamo sull'intero territorio italiano, avvalendoci di un network di professionisti legali, immobiliari e finanziari distribuito capillarmente." },
  { q: "Come posso proporre un portafoglio o una posizione?", a: "È sufficiente contattarci tramite il form della pagina Contatti o via email: il nostro team analizzerà la proposta in tempi brevi e con la massima riservatezza, ricontattandovi per definire i passi successivi." },
];

export const team = [
  {
    slug: "francesco-trotta",
    name: "Dott. Francesco Trotta",
    role: "Responsabile Selezione, Acquisto e Gestione dei Crediti",
    bio: "Responsabile dell'individuazione, analisi, acquisizione e gestione dei portafogli NPL e UTP, coordinando le attività operative e collaborando con il team legale nelle operazioni di closing e recupero.",
    initials: "FT",
  },
  {
    slug: "riccardo-achilli",
    name: "Dott. Riccardo Achilli",
    role: "Founder & CEO · Responsabile Sviluppo Commerciale",
    bio: "Guida la crescita aziendale, sviluppa partnership strategiche e coordina i rapporti con banche, fondi, investitori e intermediari finanziari.",
    initials: "RA",
  },
  {
    slug: "pino-cascioli",
    name: "Dott. Pino Cascioli",
    role: "Responsabile Finanziario",
    bio: "Coordina la pianificazione economico-finanziaria, gli investimenti e i rapporti con operatori finanziari e investitori istituzionali.",
    initials: "PC",
  },
];

export const contactInfo = {
  email: "info@vobiscredit.it",
  pec: "vobiscredit@legalmail.it",
  phone: "+39 392 772 2177",
  piva: "18541881001",
  rea: "RM1791277",
  offices: [
    {
      city: "Roma",
      label: "Sede Legale e Direzionale",
      address: "Viale dell'Arte 19/a – 00144 Roma",
      description: "Sede operativa e direzionale, punto di riferimento per il coordinamento delle attività societarie, finanziarie e di gestione dei portafogli creditizi.",
    },
    {
      city: "Milano",
      label: "Sede Commerciale",
      address: "Via Lazzaro Papi, 3 – Milano",
      description: "Dedicata allo sviluppo commerciale e alle relazioni con investitori, banche, intermediari finanziari e operatori del mercato dei crediti deteriorati, rafforzando la presenza della società nel principale polo finanziario del Paese.",
    },
  ],
};

export const heroImages = {
  home: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=2070&auto=format&fit=crop",
  chiSiamo: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=2070&auto=format&fit=crop",
  servizi: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
  percheNoi: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop",
  management: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2070&auto=format&fit=crop",
  faq: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=2070&auto=format&fit=crop",
  contatti: "https://images.unsplash.com/photo-1444723121867-7a241cacace9?q=80&w=2070&auto=format&fit=crop",
  handshake: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2070&auto=format&fit=crop",
};
